import React from "react"
import useTranslation from "../../mlang/useTranslation"
import MLink from "../../mlang/mlink"

const CutSpeedsBtn = () => {
  const equip = useTranslation('equipment')
  const t = equip['cut-speed-btn']

  return (
    <section className="card speeds-table-btn">
      <p>{t.title}</p>
      <MLink
        className="button"
        to={'/cutting-speeds-table'}
      >
        {t.action}
      </MLink>
    </section>
  )
}

export default CutSpeedsBtn